import { NewForm } from "./NewForm";
import type { NewV3Props } from "./types";

export const NewV3 = (props: NewV3Props) => <NewForm {...props} />;
